import { useContext, useEffect, useState, useRef } from 'react'
import { jobFormValidator } from '../validator';
import { DContext } from '../../context/Datacontext';
import { fetchUser } from '../../components/services/fetchUser';
import { updateJob } from '../../components/services/updateJob';
import { useParams } from 'react-router-dom';
import { fetchUpdateJob } from '../../components/services/fetchUpdateJob';
import { VALIDATION_MESSAGES } from '../../utils/validationMessages';
// import { create } from 'canvas-confetti';
// import { FaLeaf } from 'react-icons/fa';


export const CreateJobForm = () => {
    const { BeURL, currentUser, showAlert } = useContext(DContext)
    const { id } = useParams();
    const isUpdate = Boolean(id)
    const [errors, setErrors] = useState({})
    const [user, setUser] = useState([])
    const [reportManger, setReportManger] = useState(null)
    const [reportTeamLead, setReportTeamLead] = useState(null)
    const [assignedTo, setAssignedTo] = useState(null)
    const [mangerOption, setMangerOption] = useState([])
    const [teamLeadOption, setTeamLeadOption] = useState([])
    const [assignedToOption, setAssiendToOption] = useState([])
    const [primaryRecruiterOptions, setPrimaryRecruiterOptions] = useState([]);
    const [spocOption, setSpocOption] = useState([])
    const [clientOption, setClinentOption] = useState([])
    const [updatejobList, setUpdateJobList] = useState([])
    const prevManagerIdRef = useRef(null)
    const prevTeamLeadIdRef = useRef(null)
    const [loading, setLoading] = useState(false)
    const [createJob, setCreateJob] = useState({
        internalJobId: "",
        clientJobId: "",
        title: "",
        payRange: {
            currency: "",
            min: "",
            max: ""
        },
        maxClientBudget: {
            currency: "",
            amount: ""
        },
        jobType: "",
        startDate: "",
        endDate: "",
        mode: "",
        industry: "",
        location: [
        ],
        skills: [],
        minQualification: "",
        jobStatus: "",
        client: {
            id: "",
        },
        spoc: {
            id: "",
        },
        reportingManager: {
            id: ""
        },
        reportingTeamLead: {
            id: ""
        },
        assignedTo: [],
        primaryRecruiter: {
            id: ""
        },
        noticePeriod: "",
        priority: "",
        vacancies: "1",
        experience: {
            min: "",
            max: ""
        },
        description: "",
        postOnCareerPortal: false
    });

    useEffect(() => {
        if (createJob) {
            const { reportingManager, reportingTeamLead, assignedTo } = createJob;
            console.log("Reporting Manager, Team Laed and AssignedTo :", reportingManager, reportingTeamLead, assignedTo)
            let tempPrimaryRecruiterOptions = []
            // if (reportingManager?.length) {
            //     tempPrimaryRecruiterOptions.push(...reportingManager)
            // }
            if (reportingTeamLead) {
                // const teamLeadId = user.find(users => users?.id === reportingTeamLead?.id)
                // console.log("Assigend to::::::", teamLeadId)

                // const teamlLeadOptions = {
                //     value: teamLeadId?.id,
                //     label: `${teamLeadId?.fullName} (${teamLeadId?.id})`
                // }

                const teamLeadUser = user.find(
                    u => String(u.id) === String(reportingTeamLead?.id?.value)
                );

                console.log("Matched User:", teamLeadUser);

                if (teamLeadUser) {
                    const teamLeadOptions = {
                        value: teamLeadUser.id,
                        label: `${teamLeadUser.fullName} (${teamLeadUser.id})`
                    };

                    tempPrimaryRecruiterOptions.push(teamLeadOptions);
                }
                // tempPrimaryRecruiterOptions.push(reportingTeamLead)
            }
            if (assignedTo?.length) {
                tempPrimaryRecruiterOptions.push(...assignedTo)
            }

            setPrimaryRecruiterOptions(tempPrimaryRecruiterOptions.length > 0 ? tempPrimaryRecruiterOptions : null)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createJob.reportingManager, createJob.reportingTeamLead, createJob.assignedTo])
    console.log("Primary REcruiter :::", primaryRecruiterOptions)
    // const manadatroyField = {
    //     internalJobId: true,
    //     title: true,
    //     payRange: {
    //         min: true,
    //         max: true
    //     },
    //     jobType: true,
    //     mode: true,
    //     industry: true,
    //     noticePeriod: true,
    //     client: {
    //         id: true
    //     },
    //     spoc: {
    //         id: true
    //     },
    //     assignedTo: true,
    //     reportingManager: {
    //         id: true
    //     },
    //     primaryRecruiter: {
    //         id: true
    //     },
    //     experience: {
    //         min: true,
    //         max: true
    //     },
    //     city: true,
    //     skills: true,
    //     description: true
    // }

    const [filteredSpocOption, setFilteredSpocOption] = useState([]);

    // updating client and spoc
    useEffect(() => {
        const clientId =
            createJob?.client?.id?.id ??
            createJob?.client?.id ??
            createJob?.client?.value ??
            createJob?.client;
        if (!clientId) {
            setFilteredSpocOption([]);
            setCreateJob(prev => ({ ...prev, spoc: null }));
            return;
        }
        const filteredSpoc = spocOption.filter(spoc => {
            const spocClientId =
                spoc.clientId ??
                spoc.client?._id ??
                spoc.client ??
                spoc.id ??
                spoc.value;
            return String(spocClientId).trim() === String(clientId).trim();
        });
        setFilteredSpocOption(filteredSpoc);
    }, [createJob?.client, spocOption]);




    // const handleChange = (nameOrEvent, val) => {
    //     let name, value;
    //     if (nameOrEvent && nameOrEvent.target) {
    //         name = nameOrEvent.target.name;
    //         value = nameOrEvent.target.value;
    //     } else {
    //         name = nameOrEvent;
    //         value = val;
    //     }

    //     if (["reportingManager.id", "reportingTeamLead.id", "assignedTo"].includes(name)) {
    //         setCreateJob({
    //             ...createJob,
    //             primaryRecruiter: {
    //                 id: ""
    //             }
    //         })
    //     }

    //     setCreateJob((prev) => {
    //         const copy = structuredClone(prev);
    //         const keys = name.split(".");
    //         let temp = copy;

    //         keys.forEach((k, i) => {
    //             if (i === keys.length - 1) {
    //                 temp[k] = value;
    //             } else {
    //                 temp[k] = { ...temp[k] };
    //                 temp = temp[k];
    //             }
    //         });
    //         jobFormValidator(name, value, setErrors, copy, manadatroyField);
    //         return copy;
    //     });
    // };


    // Universal handleChange
    const handleChange = (nameOrEvent, val) => {
        let name, value;

        // Case A: called with the native event (e.g. handleChange(e))
        if (nameOrEvent && nameOrEvent.target && typeof nameOrEvent.target.value !== "undefined") {
            name = nameOrEvent.target.name;
            value = nameOrEvent.target.value;
        } else {
            // Case B: called with (name, value) — value might accidentally be an Event, so normalize
            name = nameOrEvent;
            value = val;

            // If someone passed the DOM event as val, extract actual value
            if (value && value.target && typeof value.target.value !== "undefined") {
                value = value.target.value;
            }
        }

        // Special case: reset primaryRecruiter
        if (["reportingManager.id", "reportingTeamLead.id", "assignedTo"].includes(name)) {
            setCreateJob((prev) => ({ ...prev, primaryRecruiter: { id: "" } }));
        }

        // Now update state using only serializable data
        setCreateJob((prev) => {
            // If prev is known to be JSON-serializable you can keep structuredClone
            const copy = structuredClone(prev);
            const keys = name.split(".");
            let temp = copy;

            keys.forEach((k, i) => {
                if (i === keys.length - 1) temp[k] = value;
                else {
                    temp[k] = { ...(temp[k] || {}) };
                    temp = temp[k];
                }
            });

            // run validator with the updated copy
            jobFormValidator(name, value, setErrors, copy);

            return copy;
        });
    };


    const handleDesChange = (value) => {
        setCreateJob((prev) => ({
            ...prev,
            description: value
        }));

        // validate description
        if (value && value.trim() !== "") {
            setErrors((prev) => ({
                ...prev,
                description: ""
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                description: "Description is required"
            }));
        }
    };


    // user fetch
    useEffect(() => {
        if (!BeURL) return;
        fetchUser({ BeURL, setUser, setSpocOption, setClinentOption, showAlert });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [BeURL]);

    // job create and update
    useEffect(() => {
        if (isUpdate) {
            fetchUpdateJob(BeURL, id, showAlert, setUpdateJobList)
        }
    }, [BeURL, id, isUpdate, showAlert, setUpdateJobList]);


    // ROLE INIT (runs on login / user list change / update mode)
    useEffect(() => {
        if (!currentUser) return;
        const userRole = currentUser?.role;
        const userId = currentUser?.id;
        if (!userRole || !userId) {
            console.warn("User role or id missing.");
            return;
        }
        if (!Array.isArray(user)) return;

        const userData = user.map(u => ({
            id: u?.id || "",
            fullName: u?.fullName || "",
            role: u?.role || "",
            reportingManagerId: u?.reportingManager?.reportingManagerId || null,
            reportingTeamLeadId: u?.reportingTeamLead?.reportingTeamLeadId || null,
            raw: u
        }));
        console.log("UserDatass:", userData)
        // ---- 1) ADMIN ----
        if (userRole === "admin") {
            const managers = userData.filter(u => u.role === "manager");
            const managerOptions = managers.map(m => ({
                value: m.id,
                label: `${m.fullName} (${m.id})`
            }));
            setReportManger(managers);
            setMangerOption(managerOptions);
            // setAssiendToOption(managerOptions);
            const assignedToLists = user.filter(users => users.role !== 'admin' && users.role !== 'manager' && users.isEmployee !== false && users.isEmployee !== false)
            console.log("Assigend to:", assignedToLists)

            const assignedToListsOptions = assignedToLists.map(assign => ({
                value: assign.id,
                label: `${assign.fullName} (${assign.id})`
            }))
            setAssiendToOption(assignedToListsOptions)

            return;
        }
        console.log("UserDatass:", userData)
        // ---- 2) MANAGER ----
        if (userRole === "manager") {
            const manager = userData.find(f => f.id?.toLowerCase() === userId?.toLowerCase());
            if (!manager) return;

            // single manager option (object) for the Manager role
            const managerOption = { value: manager.id, label: `${manager.fullName} (${manager.id})` };
            setMangerOption(managerOption);

            // team leads under this manager
            const teamLeads = userData.filter(u => u.role === "teamlead" && u.reportingManagerId === manager.id && u.raw?.isEmployee !== false);
            const teamLeadOptions = teamLeads.map(tl => ({ value: tl.id, label: `${tl.fullName} (${tl.id})` }));
            setTeamLeadOption(teamLeadOptions);

            // default assignedTo: show teamLeads under manager (so manager can choose team leads) + manager self as fallback
            // setAssiendToOption([...teamLeadOptions, managerOption]);

            const assignedToLists = user.filter(users => users.role !== 'admin' && users.role !== 'manager' && users.isEmployee !== false)

            console.log("Assigend to:", assignedToLists)

            const assignedToListsOptions = assignedToLists.map(assign => ({
                value: assign.id,
                label: `${assign.fullName} (${assign.id})`
            }))
            setAssiendToOption(assignedToListsOptions)
            return;
        }

        // 3) TEAMLEAD 
        //TEAM LEAD LOGIN (replace old block) 
        if (userRole === "teamlead") {
            const teamLead = userData.find(f => f.id === userId);
            if (!teamLead) return;
            //Find manager (robust)
            const manager = userData.find(m =>
                m.id === teamLead.reportingManagerId ||
                (teamLead.raw?.reportingManager && (
                    teamLead.raw.reportingManager.reportingManagerId === m.id ||
                    teamLead.raw.reportingManager.reporingManagerId === m.id
                ))
            );

            const teamLeadOption = { value: teamLead.id, label: `${teamLead.fullName} (${teamLead.id})` };
            setReportTeamLead(teamLeadOption);

            if (manager) {
                const managerOption = { value: manager.id, label: `${manager.fullName} (${manager.id})` };
                setMangerOption(managerOption);

                //Update createJob defaults
                setCreateJob(prev => ({
                    ...prev,
                    reportingManager: { id: managerOption },
                    reportingTeamLead: { id: teamLeadOption }
                }));
            } else {
                setCreateJob(prev => ({
                    ...prev,
                    reportingTeamLead: { id: teamLeadOption }
                }));
            }

            //Recruiters under this team lead
            // const recruiters = userData.filter(
            //     u => u.role === "recruiter" && u.reportingTeamLeadId === teamLead.id
            // );
            // const recruiterOptions = recruiters.map(r => ({
            //     value: r.id,
            //     label: `${r.fullName} (${r.id})`
            // }));

            //AssignTo = [TeamLead + Recruiters]
            // const assignToList = [teamLeadOption, ...recruiterOptions];

            //Show in dropdown but no default selection
            setAssignedTo(null);
            // setAssiendToOption(assignToList);
            const assignedToLists = user.filter(users => users.role !== 'admin' && users.role !== 'manager' && users.isEmployee !== false)
            console.log("Assigend to:", assignedToLists)

            const assignedToListsOptions = assignedToLists.map(assign => ({
                value: assign.id,
                label: `${assign.fullName} (${assign.id})`
            }))
            setAssiendToOption(assignedToListsOptions)
            return;
        }

        //4) RECRUITER
        if (userRole === "recruiter") {
            const recruiter = userData.find(r => r.id === userId);
            if (!recruiter) return;
            // robust teamLead id (support nested shapes)
            const teamLeadId =
                recruiter.reportingTeamLeadId ||
                (recruiter.raw && recruiter.raw.reportingTeamLead && (recruiter.raw.reportingTeamLead.reportingTeamLeadId || recruiter.raw.reportingTeamLead.reporingTeamLeadId)) ||
                null;

            // robust manager id (support nested shapes)
            const managerId =
                recruiter.reportingManagerId ||
                (recruiter.raw && recruiter.raw.reportingManager && (recruiter.raw.reportingManager.reportingManagerId || recruiter.raw.reportingManager.reporingManagerId)) ||
                null;

            // find objects
            const teamLead = userData.find(tl => tl.id === teamLeadId);
            const manager = userData.find(m => m.id === managerId);

            // prepare options
            const makeOption = u => ({ value: u.id, label: `${u.fullName} (${u.id})` });
            const selfOption = { value: recruiter.id, label: `${recruiter.fullName} (${recruiter.id})` };

            // set manager & teamLead defaults (so their inputs show filled)
            if (manager) {
                const managerOption = makeOption(manager);
                setMangerOption(managerOption);
            }
            if (teamLead) {
                const teamLeadOption = makeOption(teamLead);
                setReportTeamLead(teamLeadOption);

                // set createJob defaults so React-Select controlled values show
                setCreateJob(prev => ({
                    ...prev,
                    reportingManager: manager ? { id: makeOption(manager) } : prev.reportingManager,
                    reportingTeamLead: { id: teamLeadOption }
                }));

                setAssiendToOption(selfOption);
                setPrimaryRecruiterOptions(selfOption)
                // also reflect in createJob
                setCreateJob(prev => ({ ...prev, assignedTo: [selfOption] }));
                setCreateJob(prev => ({ ...prev, primaryRecruiter: { id: selfOption } }));
            } else {
                // fallback: if teamLead not found, still show self and manager if available
                const list = [];
                if (manager) list.push(makeOption(manager));
                list.push(selfOption);
                setAssiendToOption(list);
                setAssignedTo(selfOption);
                setCreateJob(prev => ({
                    ...prev,
                    reportingManager: manager ? { id: makeOption(manager) } : prev.reportingManager,
                    assignedTo: { id: selfOption }
                }));
            }

            return;
        }
    }, [currentUser, user, isUpdate, updatejobList]);

    //TEAM LEAD OPTIONS (when reportingManager changes)
    useEffect(() => {
        const managerId = createJob?.reportingManager?.id?.value;
        if (!managerId || !Array.isArray(user)) return;
        const teamLeads = user.filter(
            u =>
                u.role === "teamlead" &&
                u.reportingManager &&
                (
                    u.reportingManager.reportingManagerId === managerId ||
                    u.reportingManager.reporingManagerId === managerId
                )
                && u.isEmployee !== false
        );
        const teamLeadOptions = teamLeads.map(tl => ({ value: tl.id, label: `${tl.fullName} (${tl.id})` }));
        setTeamLeadOption(teamLeadOptions);
    }, [createJob?.reportingManager?.id?.value, user]);

    //ASSIGNED TO OPTIONS (when teamLead OR manager selection changes)
    useEffect(() => {
        const teamLeadId = createJob?.reportingTeamLead?.id?.value;
        const managerId = createJob?.reportingManager?.id?.value;
        const role = currentUser?.role;
        const currentUserId = currentUser?.id;
        if (!Array.isArray(user)) return;
        //Helper to create select options
        // const makeOption = (u) => ({
        //     value: u.id,
        //     label: `${u.fullName} (${u.id})`,
        // });
        //Manager changed → reset TeamLead & AssignedTo
        if (
            role === "admin" &&
            prevManagerIdRef.current &&
            prevManagerIdRef.current !== managerId
        ) {
            setCreateJob((prev) => ({
                ...prev,
                reportingTeamLead: null,
                assignedTo: null,
            }));
            // setAssiendToOption([]);
            const assignedToLists = user.filter(users => users.role !== 'admin' && users.role !== 'manager' && users.isEmployee !== false)
            console.log("Assigend to:", assignedToLists)


            const assignedToListsOptions = assignedToLists.map(assign => ({
                value: assign.id,
                label: `${assign.fullName} (${assign.id})`
            }))
            setAssiendToOption(assignedToListsOptions)
        }
        //TeamLead changed → reset only AssignedTo
        if (
            createJob.assignedTo &&
            prevTeamLeadIdRef.current !== teamLeadId
        ) {
            if (role === "admin" || role === "manager") {
                setCreateJob((prev) => ({
                    ...prev,
                    assignedTo: null,
                }));
                // setAssiendToOption([]);
                const assignedToLists = user.filter(users => users.role !== 'admin' && users.role !== 'manager' && users.isEmployee !== false)
                console.log("Assigend to:", assignedToLists)

                const assignedToListsOptions = assignedToLists.map(assign => ({
                    value: assign.id,
                    label: `${assign.fullName} (${assign.id})`
                }))
                setAssiendToOption(assignedToListsOptions)
            }
        }
        // Update previous IDs (do AFTER checking above)
        prevManagerIdRef.current = managerId;
        prevTeamLeadIdRef.current = teamLeadId;

        // CASE 1: ADMIN
        if (role === "admin") {
            //TEAMLEAD SELECTED
            if (teamLeadId) {
                // const selectedTL = user.find(
                //     (u) => u.role === "teamlead" && u.id === teamLeadId
                // );
                // const manager =
                //     selectedTL?.reportingManager?.reportingManagerId
                //         ? user.find(
                //             (m) =>
                //                 m.id ===
                //                 selectedTL.reportingManager.reportingManagerId
                //         )
                //         : null;

                // const recruiters = user.filter(
                //     (u) =>
                //         u.role === "recruiter" &&
                //         u.reportingTeamLead &&
                //         u.reportingTeamLead.reportingTeamLeadId === teamLeadId
                // );

                // const final = [
                //     ...(manager ? [makeOption(manager)] : []),
                //     ...(selectedTL ? [makeOption(selectedTL)] : []),
                //     ...recruiters.map(makeOption),
                // ];

                // setAssiendToOption(final);
                const assignedToLists = user.filter(users => users.role !== 'admin' && users.role !== 'manager' && users.isEmployee !== false)

                console.log("Assigend to:", assignedToLists)

                const assignedToListsOptions = assignedToLists.map(assign => ({
                    value: assign.id,
                    label: `${assign.fullName} (${assign.id})`
                }))
                setAssiendToOption(assignedToListsOptions)
                return;
            }
            //MANAGER SELECTED
            if (managerId) {
                // const manager = user.find((u) => u.id === managerId);

                // const teamLeads = user.filter(
                //     (u) =>
                //         u.role === "teamlead" &&
                //         u.reportingManager &&
                //         u.reportingManager.reportingManagerId === managerId
                // );

                // const final = [
                //     ...(manager ? [makeOption(manager)] : []),
                //     ...teamLeads.map(makeOption),
                // ];
                // setAssiendToOption(final);
                const assignedToLists = user.filter(users => users.role !== 'admin' && users.role !== 'manager' && users.isEmployee !== false)
                console.log("Assigend to:", assignedToLists)

                const assignedToListsOptions = assignedToLists.map(assign => ({
                    value: assign.id,
                    label: `${assign.fullName} (${assign.id})`
                }))
                setAssiendToOption(assignedToListsOptions)
                return;
            }
            // NOTHING SELECTED
            // const managers = user.filter((u) => u.role === "manager");
            // setAssiendToOption(managers.map(makeOption));
            const assignedToLists = user.filter(users => users.role !== 'admin' && users.role !== 'manager' && users.isEmployee !== false)
            console.log("Assigend to:", assignedToLists)


            const assignedToListsOptions = assignedToLists.map(assign => ({
                value: assign.id,
                label: `${assign.fullName} (${assign.id})`
            }))
            setAssiendToOption(assignedToListsOptions)
            return;
        }

        // CASE 2: MANAGER
        if (role === "manager") {
            //If TeamLead is selected
            if (teamLeadId) {
                // const selectedTL = user.find(
                //     (u) => u.role === "teamlead" && u.id === teamLeadId
                // );
                // const recruiters = user.filter(
                //     (u) =>
                //         u.role === "recruiter" &&
                //         u.reportingTeamLead &&
                //         u.reportingTeamLead.reportingTeamLeadId === teamLeadId
                // );
                // const recruiterOptions = recruiters.map(makeOption);
                // const final = selectedTL
                //     ? [makeOption(selectedTL), ...recruiterOptions]
                //     : recruiterOptions;

                // setAssiendToOption(final);
                const assignedToLists = user.filter(users => users.role !== 'admin' && users.role !== 'manager' && users.isEmployee !== false)
                console.log("Assigend to:", assignedToLists)

                const assignedToListsOptions = assignedToLists.map(assign => ({
                    value: assign.id,
                    label: `${assign.fullName} (${assign.id})`
                }))
                setAssiendToOption(assignedToListsOptions)
                return;
            }
            //No TeamLead selected → show current manager's team leads + manager itself
            // const teamLeads = user.filter(
            //     (u) =>
            //         u.role === "teamlead" &&
            //         u.reportingManager &&
            //         u.reportingManager.reportingManagerId === currentUserId
            // );

            // const teamLeadOptions = teamLeads.map(makeOption);
            // include current manager also as option
            // const managerOption = makeOption(currentUser);
            // setAssiendToOption([...teamLeadOptions, managerOption]);
            const assignedToLists = user.filter(users => users.role !== 'admin' && users.role !== 'manager' && users.isEmployee !== false)

            console.log("Assigend to:", assignedToLists)

            const assignedToListsOptions = assignedToLists.map(assign => ({
                value: assign.id,
                label: `${assign.fullName} (${assign.id})`
            }))
            setAssiendToOption(assignedToListsOptions)
            return;
        }

        // CASE 3: TEAMLEAD
        if (role === "teamlead") {
            const teamLead = user.find((u) => u.id === currentUserId);
            if (!teamLead) return;
            // const recruiters = user.filter(
            //     (u) =>
            //         u.role === "recruiter" &&
            //         u.reportingTeamLead &&
            //         u.reportingTeamLead.reportingTeamLeadId === currentUserId
            // );
            // const teamLeadOption = makeOption(teamLead);
            // const recruiterOptions = recruiters.map(makeOption);
            // setAssiendToOption([teamLeadOption, ...recruiterOptions]);
            const assignedToLists = user.filter(users => users.role !== 'admin' && users.role !== 'manager' && users.isEmployee !== false)
            console.log("Assigend to:", assignedToLists)


            const assignedToListsOptions = assignedToLists.map(assign => ({
                value: assign.id,
                label: `${assign.fullName} (${assign.id})`
            }))
            setAssiendToOption(assignedToListsOptions)
            setAssignedTo(null);
            return;
        }
        // CASE 4: RECRUITER
        if (role === "recruiter") {
            // const recruiter = user.find((u) => u.id === currentUserId);
            // setAssiendToOption(recruiter ? [makeOption(recruiter)] : []);
            const assignedToLists = user.filter(users => users.role !== 'admin' && users.role !== 'manager' && users.isEmployee !== false)
            console.log("Assigend to:", assignedToLists)


            const assignedToListsOptions = assignedToLists.map(assign => ({
                value: assign.id,
                label: `${assign.fullName} (${assign.id})`
            }))
            setAssiendToOption(assignedToListsOptions)
            return;
        }

        // fallback
        // setAssiendToOption([]);
        const assignedToLists = user.filter(users => users.role !== 'admin' && users.role !== 'manager' && users.isEmployee !== false)
        console.log("Assigend to:", assignedToLists)


        const assignedToListsOptions = assignedToLists.map(assign => ({
            value: assign.id,
            label: `${assign.fullName} (${assign.id})`
        }))
        setAssiendToOption(assignedToListsOptions)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        createJob?.reportingTeamLead?.id?.value,
        createJob?.reportingManager?.id?.value,
        user,
        currentUser?.role,
        currentUser?.id,
    ]);

    //DEFAULT MANAGER SET FOR MANAGER LOGIN 
    useEffect(() => {
        if (currentUser?.role !== "manager" || !mangerOption) return;
        // mangerOption might be an object or array depending on earlier logic
        let defaultManager = null;
        if (Array.isArray(mangerOption)) {
            defaultManager = mangerOption.find(m => m.value === currentUser.id);
        } else if (mangerOption?.value) {
            defaultManager = mangerOption.value === currentUser.id ? mangerOption : null;
        }
        if (defaultManager) {
            setCreateJob(prev => ({
                ...prev,
                reportingManager: { id: defaultManager },
                assignedTo: updatejobList?.assignedTo?.length > 0 ? updatejobList?.assignedTo?.map(item => ({
                    label: `${item.name} (${item.id})`,
                    value: item.id
                })) : []
            }));
        }
    }, [currentUser?.role, currentUser?.id, mangerOption, updatejobList]);

    // UPDATE MODE: prefill existing job values (admin update case)
    useEffect(() => {
        if (!isUpdate || !updatejobList) return;
        if (currentUser?.role !== "admin") return;
        // reportingManager prefill (mangerOption might be array)
        if (updatejobList.reportingManager) {
            const mgrId = updatejobList.reportingManager?.id;
            let defaultManager = null;
            if (Array.isArray(mangerOption)) defaultManager = mangerOption.find(opt => opt.value === mgrId);
            else if (mangerOption?.value === mgrId) defaultManager = mangerOption;

            if (defaultManager) {
                setCreateJob(prev => ({ ...prev, reportingManager: { id: defaultManager } }));

            }
        } else {
            setCreateJob(prev => ({ ...prev, reportingManager: null }));
        }
    }, [isUpdate, updatejobList, mangerOption, currentUser]);

    useEffect(() => {
        if (isUpdate && updatejobList) {
            if (currentUser.role === "admin") {
                if (updatejobList.reportingManager) {
                    const defaultManager = mangerOption.find(
                        opt => opt.value === updatejobList?.reportingManager?.id
                    );
                    if (defaultManager) {
                        setCreateJob(prev => ({
                            ...prev,
                            reportingManager: { id: defaultManager },
                            assignedTo: updatejobList?.assignedTo?.length > 0 ? updatejobList?.assignedTo?.map(item => ({
                                label: `${item.name} (${item.id})`,
                                value: item.id
                            })) : []
                        }));
                    }
                } else {
                    setCreateJob(prev => ({ ...prev, reportingManager: null }));
                }
            }
        }
    }, [reportManger, mangerOption, reportTeamLead, assignedTo, currentUser, updatejobList, isUpdate])

    // update job
    useEffect(() => {

        if (!isUpdate || !updatejobList) return;
        const job = updatejobList;

        setCreateJob({
            internalJobId: job.internalJobId || "",
            title: job.title || "",
            clientJobId: job.clientJobId || "",

            payRange: {
                currency: job.payRange?.currency ? job.payRange.currency : "",
                min: job.payRange?.min ?? "",
                max: job.payRange?.max ?? ""
            },

            startDate: job.startDate ? job.startDate.split('T')[0] : "",
            endDate: job.endDate ? job.endDate.split('T')[0] : "",

            maxClientBudget: {
                currency: job.maxClientBudget?.currency ? job.maxClientBudget.currency : "",
                amount: job.maxClientBudget?.amount ?? ""
            },

            jobType: job.jobType || "",
            city: job.location?.length ? job.location.map(i => i.city) : [],

            mode: job.mode || "",
            industry: job.industry || "",

            skills: Array.isArray(job.skills) ? job.skills.map(s => ({ label: s, value: s })) : [],

            minQualification: job.minQualification || "",
            jobStatus: job.jobStatus || "",

            spoc: { id: job?.spoc && { label: job.spoc.name, value: job.spoc.id } },
            client: { id: job?.client && { label: job.client.name, value: job.client.id } },


            reportingManager: job.reportingManager ? { id: { label: job?.reportingManager?.id, value: job?.reportingManager?.id } } : null,
            reportingTeamLead: job.reportingTeamLead
                ? {
                    id: {
                        label: `${job.reportingTeamLead.name} (${job.reportingTeamLead.id})`,
                        value: job.reportingTeamLead.id
                    }
                }
                : [],
            assignedTo: job?.assignedTo?.length > 0 ? job?.assignedTo?.map(item => ({
                label: `${item.name} (${item.id})`,
                value: item.id
            })) : [],
            primaryRecruiter: job?.primaryRecruiter ? { id: { label: `${job.primaryRecruiter.name} (${job.primaryRecruiter.id})`, value: job?.primaryRecruiter?.id } } : null,
            noticePeriod: { label: job.noticePeriod, value: job.noticePeriod } || "",
            priority: job.priority || "",
            vacancies: job.vacancies ?? "",

            experience: {
                min: job.experience?.min ?? "",
                max: job.experience?.max ?? ""
            },
            description: job.description || "",
            postOnCareerPortal: !!job.postOnCareerPortal
        });
    }, [isUpdate, updatejobList]);

    // const handleSubmit = () => {
    //     updateJob(BeURL, createJob, showAlert, isUpdate, id, {}, setLoading);
    // };

    console.log("desic", createJob.experience)

    console.log("city", createJob?.city)
    const handleSubmit = () => {
        const newErrors = {};

        // Internal job id
        if (!createJob.internalJobId.trim()) {
            newErrors["internalJobId"] = VALIDATION_MESSAGES?.REQUIRED
        }

        // job Title
        if (!createJob?.title.trim()) {
            newErrors["title"] = VALIDATION_MESSAGES?.REQUIRED
        }

        // Job type
        if (!createJob?.jobType) {
            newErrors["jobType"] = VALIDATION_MESSAGES?.REQUIRED
        }

        if (!createJob?.payRange?.min) {
            newErrors["payRange.min"] = VALIDATION_MESSAGES?.REQUIRED
        }

        if (!createJob?.payRange?.max) {
            newErrors["payRange.max"] = VALIDATION_MESSAGES?.REQUIRED
        }

        if (!createJob?.experience?.min) {
            newErrors["experience.min"] = VALIDATION_MESSAGES?.REQUIRED
        }

        if (!createJob?.experience?.max) {
            newErrors["experience.max"] = VALIDATION_MESSAGES?.REQUIRED
        }


        // Mode
        if (!createJob?.mode) {
            newErrors["mode"] = VALIDATION_MESSAGES?.REQUIRED
        }

        if (!createJob?.industry) {
            newErrors["industry"] = VALIDATION_MESSAGES?.REQUIRED
        }

        if (!createJob.noticePeriod) {
            newErrors["noticePeriod"] = VALIDATION_MESSAGES?.REQUIRED
        }

        if (!createJob?.reportingManager?.id) {
            newErrors["reportingManager.id"] = VALIDATION_MESSAGES?.REQUIRED
        }

        if (createJob?.assignedTo === null) {
            newErrors["assignedTo"] = VALIDATION_MESSAGES?.REQUIRED
        }


        if (!createJob?.primaryRecruiter?.id) {
            newErrors["primaryRecruiter.id"] = VALIDATION_MESSAGES?.REQUIRED
        }

        if (!createJob?.client?.id) {
            newErrors["client.id"] = VALIDATION_MESSAGES?.REQUIRED
        }

        if (!createJob?.spoc?.id) {
            newErrors["spoc.id"] = VALIDATION_MESSAGES?.REQUIRED
        }

        if (createJob?.city === null || createJob?.city === undefined) {
            newErrors["city"] = VALIDATION_MESSAGES?.REQUIRED
        }

        if (createJob?.skills?.length === 0) {
            newErrors["skills"] = VALIDATION_MESSAGES?.REQUIRED
        }


        const strippedDescription = createJob?.description
            ?.replace(/<[^>]*>/g, "")
            ?.trim();

        if (!strippedDescription) {
            newErrors.description = VALIDATION_MESSAGES.REQUIRED;
        }



        // ✅ Set errors properly
        setErrors((prev) => ({
            ...prev,
            ...newErrors
        }));

        // ✅ Stop API call if validation fails
        if (Object.keys(newErrors).length > 0) {
            console.log("Validation failed:", newErrors); // ✅ debug
            return;
        }

        console.log("Validation passed ✅"); // ✅ debug
        updateJob(BeURL, createJob, showAlert, isUpdate, id, {}, setLoading);
    }

    return { createJob, setCreateJob, handleChange, errors, currentUser, reportTeamLead, assignedTo, teamLeadOption, mangerOption, assignedToOption, handleSubmit, filteredSpocOption, clientOption, isUpdate, primaryRecruiterOptions, loading, handleDesChange };
}


